/*
 * @Author: lc
 * @Date: 2022-07-26 15:08:59
 * @LastEditors: lc
 * @LastEditTime: 2022-07-26 15:10:29
 * @Description: 
 */
/**
  * 展厅 接口的出口
  */
import axios from '.././http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块，把请求字段直接映射过来


// 接口请求地址
const api = '/c-api/';

const showroom = {
    // 列表
    list (params) {
        return axios.get(api + 'showroom/list', { params: params })
    },
    //添加
    create (params) {
        return axios.post(api + 'showroom/create', qs.stringify(params))
    },
    //获取编辑信息
    detail (params) {
        return axios.get(api + 'showroom/detail', { params: params })
    },
    //修改
    edit (params) {
        return axios.post(api + 'showroom/edit', qs.stringify(params))
    },
    //删除
    remove (params) {
        return axios.post(api + 'showroom/remove', qs.stringify(params))
    }
}


// 导出接口
export default showroom
